import * as React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
/**
 * @ignore - internal component.
 */

export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/lab/esm/internal/svg-icons/LastPage.js
// module id = 1696
// module chunks = 121